import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CenterContent from '../Components/CenterContent/CenterContent'
import InstrumentsWrrapper from '../Components/InstrumentsWrrapper/InstrumentsWrrapper'
import { observer } from 'mobx-react-lite'
import { student } from '../store/student.ts'
import ApplicationsExpect from './../block/applications/ApplicationsExpect'
import ApplicaionsDone from './../block/applications/ApplicationsDone'
import { report } from './../store/report'
import CheckBox from '../Components/CheckBox/CheckBox'
import http from './../Service/http'
import { direction } from '../store/direction'
import { IoMdThermometer } from 'react-icons/io'
import EmbassiesModal from '../Components/Modal/EmbassiesModal'
import SocialFundModal from '../Components/Modal/SocialFundModal'
import AboutLearningModal from '../Components/Modal/AboutLearningModal'
// import BlueBtn from "../Components/SidBarButtons/BlueBtn";
// import Input from "react-select/dist/declarations/src/components/Input";
import { auth } from '../store/auth'
import { toast } from 'react-toastify'
import CallModal from '../Components/Modal/CallModal'
import SpravkaFinishingModal from '../Components/Modal/SpravkaFinishingModal'

export const ApplicationContainer = observer(function () {
	const [form, setForm] = useState(false)
	const [embassies, setEmbassies] = useState(false)
	const [openSocial, setSocial] = useState(false)
	const [openLearn, setLearn] = useState(false)
	const { t, i18n } = useTranslation()
	const [isIspol, setIsIspol] = useState(false)

	const getReports = async id => {
		const a = await http.post('/report/reportApplicationWait?reportType=' + id)
		report.newReport(a.data.reportApplicationWait)
	}
	useEffect(() => {
		getReports(0)
	}, [])

	const openForm = () => {
		setForm(!form)
		setEmbassies(!embassies)
		setSocial(!openSocial)
		setLearn(!openLearn)
	}

	const ispolnitelUpdate = async () => {
		const res = await http.post('/okno/ispolnitelStatus', {
			id_zakaz: student.student.id_okno_zakaz,
			AVN_operator: auth.user.data.id,
			doc: student.student.id_okno_document
		})
		if (res.data.result !== null) {
			toast(res.data.result)
			getReports()
			setIsIspol(false)
		}
	}
	useEffect(() => {
		if (isIspol) {
			ispolnitelUpdate()
		}
	}, [isIspol])

	return (
		<CenterContent>
			<InstrumentsWrrapper
				leftHead={t('st:instrument.titles.appsExpected')}
				rightHead={t('st:instrument.titles.doneApps')}
				leftChilds={<ApplicationsExpect />}
				rightChilds={<ApplicaionsDone />}
			/>
			<div className='TableWrapper'>
				<table>
					<thead>
						<tr>
							<th style={{ width: '5%' }}>№</th>
							<th style={{ width: '35%', textAlign: 'left' }}>{t('st:table.fio')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.executor')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.group')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.doc')}</th>
							<th style={{ width: '10%', textAlign: 'center' }}>{t('st:appTitle.titles.number')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.type')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.dateApp')}</th>
							{direction.leftOrRight == 'left' ? (
								<th style={{ width: '10%' }}>{t('st:appTitle.titles.status')}</th>
							) : (
								<th style={{ width: '10%' }}>{t('st:appTitle.titles.doned')}</th>
							)}
							{direction.leftOrRight == 'left' ? (
								<th style={{ width: '10%' }}>{t('st:appTitle.titles.esp')}</th>
							) : (
								<th style={{ width: '10%' }}>{t('st:appTitle.titles.doned')}</th>
							)}
						</tr>
					</thead>
					<tbody>
						{report.reportExpected.map((item, index) => {
							return (
								<tr
									onClick={() => {
										student.newStudent(item)
									}}
								>
									<td>{index + 1}</td>
									<td style={{ textAlign: 'left' }}>{item.s_fio}</td>
									{item.status_new === false ? (
										<td onClick={() => setIsIspol(true)} style={{ color: '#2f80ed', fontWeight: 'bold' }}>
											{item.ispolnitel}
										</td>
									) : (
										<td>{item.ispolnitel}</td>
									)}
									<td>{item.groups}</td>
									{item.status_new === true ? (
										<td onClick={openForm} style={{ color: '#2f80ed', fontWeight: 'bold' }}>
											{item.okno_document}
										</td>
									) : (
										<td>{item.okno_document}</td>
									)}
									<td>{item.reference_number}</td>

									<td>{item.status_online_offline}</td>
									<td>{item.date_insert}</td>

									{direction.leftOrRight == 'left' ? (
										<td
											style={{
												display: 'flex',
												justifyContent: 'center',
												alignItems: 'center'
											}}
										>
											{item.date_viewed ? (
												<CheckBox
													onchange={async e => {
														const res = await http.post('/report/reportApplicationUpdate', {
															id_okno_zakaz: item.id_okno_zakaz,
															id_okno_document: item.id_okno_document,
															status: 1
														})
														if (res.data.result === 'Заявка выполнено') {
															getReports(report.currentType)
														}
													}}
													checked={item.status}
													item={item}
													active={true}
													dsbl={false}
													name=''
													styles={{ width: '17px' }}
												/>
											) : (
												<p className='new_report'>Новый</p>
											)}
										</td>
									) : (
										<td
											style={{
												display: 'flex',
												justifyContent: 'center',
												alignItems: 'center'
											}}
										>
											<p className='new_report' style={{ fontWeight: 400 }}>
												{item.date_viewed}
											</p>
										</td>
									)}

									{direction.leftOrRight == 'left' ? (
										<td
											style={{
												justifyContent: 'center',
												alignItems: 'center'
											}}
										>
											{item.date_viewed ? (
												<CheckBox
													onchange={async e => {
														const res = await http.post('/report/reportApplicationEdsUpdate', {
															id_okno_zakaz: item.id_okno_zakaz,
															id_okno_document: item.id_okno_document,
															status: 1,
															EDS: 1
														})
														if (res.data.result === 'Заявка отправлено на подпись') {
															getReports(report.currentType)
														}
													}}
													checked={item.EDS}
													item={item}
													active={true}
													dsbl={false}
													name=''
													styles={{ width: '17px' }}
												/>
											) : (
												<p className='new_report'>Новый</p>
											)}
										</td>
									) : (
										<td
											style={{
												marginLeft: "20px",
												justifyContent: 'center',
												alignItems: 'center'
											}}
										>
											<p className='new_report' style={{ fontWeight: 400 }}>
												{item.date_viewed}
											</p>
										</td>
									)}
								</tr>
							)
						})}
					</tbody>
				</table>
				{student.student.id_okno_document === 10 ? embassies && <EmbassiesModal openForm={openForm} /> : null}
				{student.student.id_okno_document === 3 ? openSocial && <SocialFundModal openForm={openForm} /> : null}
				{student.student.id_okno_document === 4 ? openLearn && <AboutLearningModal openForm={openForm} /> : null}
				{student.student.id_okno_document === 9 ? openLearn && <CallModal openForm={openForm} /> : null}
				{student.student.id_okno_document === 5 ? openLearn && <SpravkaFinishingModal openForm={openForm} /> : null}
				{student.student.id_okno_document !== 10 &&
					student.student.id_okno_document !== 3 &&
					student.student.id_okno_document !== 9 &&
					student.student.id_okno_document !== 5
						? form && <AboutLearningModal openForm={openForm} />
						: null}
			</div>
		</CenterContent>
	)
})
